// 项目现场勘察表
<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <!-- 第一行-项目名称 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_xiangm@2x.png" alt />
        <span>项目名称</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{S_project_name}}</span>
      </div>
    </div>
    <!-- 第二行--现场检查地点and检查时间 -->
    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:14px" src="../../assets/image/icon_dzhi@2x.png" alt />
          <span>现场检查地点</span>
        </div>
        <div class="rightInput">
          <el-input :disabled="!isSubmit" v-model="addFormData.inspection_location"></el-input>
        </div>
      </div>
      <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:17px" src="../../assets/image/icon_riqi@2x.png" alt />
          <span>检查时间</span>
        </div>
        <div class="rightInput">
          <el-date-picker
            :disabled="!isSubmit"
            v-model="addFormData.inspection_time"
            type="date"
            :placeholder="isSubmit ? '选择日期' : ''"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
      </div>
    </div>
    <!-- 第三行--检查人员 -->
    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
          <span>检查人员</span>
        </div>
        <div class="rightInput">
          <el-input :disabled="!isSubmit" v-model="addFormData.inspectors"></el-input>
        </div>
      </div>
    </div>
    <!-- 第四行--现场情况记录 -->
    <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:650px">
        <img style="width:15px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>现场情况记录</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.site_record"
        :autosize="{minRows: 3}"
        type="textarea"
      ></el-input>
    </div>
    <!-- 第五行--检查意见 -->
    <!-- <div class="oneRow" style="margin-bottom:23px">
      <div class="leftLabel" style="width:650px">
        <img style="width:15px" src="../../assets/image/icon_yijian@2x.png" alt />
        <span>检查意见</span>
      </div>
    </div>
    <div class="ProjectTextAreaBox" style="margin-bottom:31px;">
      <el-input
        :disabled="!isSubmit"
        v-model="addFormData.inspection_opinion"
        placeholder="请输入检查意见"
        :autosize="{minRows: 3}"
        type="textarea"
      ></el-input>
    </div>-->
    <!-- 签字 -->
    <!-- <div class="writeName" style="justify-content:flex-start">
      <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
      <span style="width:120px">记录人签字</span>
      <img
        v-if="!addFormData.sign_recorder"
        @click="handleReceiverFlag1"
        style="width:66px;"
        src="../../assets/image/zaixianqianm@2x.png"
        alt
      />
      <img
        v-if="addFormData.sign_recorder"
        @click="handleReceiverFlag1(addFormData.sign_recorder)"
        style="width:66px;"
        :src="addFormData.sign_recorder"
        alt
      />
    </div>
    <div class="writeName" style="justify-content:flex-start;margin-bottom:25px">
      <img style="width:16px;margin-right:10px" src="../../assets/image/icon_qian@2x.png" alt />
      <span style="width:120px">企业人员签字</span>
      <img
        v-if="!addFormData.sign_enterprise"
        @click="handleReceiverFlag2"
        style="width:66px;"
        src="../../assets/image/zaixianqianm@2x.png"
        alt
      />
      <img
        v-if="addFormData.sign_enterprise"
        @click="handleReceiverFlag2(addFormData.sign_enterprise)"
        style="width:66px;"
        :src="addFormData.sign_enterprise"
        alt
      />
    </div>-->
    <!-- 第五行--上传附件 -->
    <div class="oneRow">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>上传附件</span>
      </div>
      <div class="rightInput">
        <upload-file
          :isSubmit="isSubmit"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>

    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel"></div>
      <div class="rightInput">
        <span
          style="color:rgb(245, 95, 95);font-size:14px;"
        >* 现场勘察记录：请上传现场勘察记录，现场照片及现场视频（员工需穿公司工装，照片和视频要包含企业标志性建筑；煤矿项目最好有下井视频或照片）,模板文件：</span>
        <a style="font-size:14px;" href="http://control.sxpz.vip/Template/现场勘察记录.doc">现场勘察记录.doc</a>
      </div>
    </div>
    <!-- 审批备注 -->
    <div class="oneRow" style="margin-bottom:35px;margin-top:20px" v-if="addFormData.is_approve==1">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>审批备注</span>
      </div>
      <div class="rightInput">
        <el-input v-model="approval_remark"></el-input>
      </div>
    </div>

    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button @click="handleSubmit('1')" v-if="addFormData.is_edit!='1'">保存草稿</el-button>
      <el-button
        v-if="addFormData.withdraw_status=='1'"
        @click="handleProjectWithDraw"
        style="background-color:rgb(255, 26, 26);"
      >撤回</el-button>
      <el-button
        style="background-color:#40A0F2"
        @click="handleSubmit('0')"
        v-if="addFormData.is_edit!='1'"
      >提交</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('-1')"
        style="background-color:#f4a029"
      >驳回</el-button>
      <el-button
        v-if="addFormData.is_approve==1"
        @click="handleExamine('1')"
        style="background-color:#40A0F2"
      >审批通过</el-button>
    </div>
    <!-- 按钮行 -->
    <!-- 签名组件 -->
    <sign-dialog
      @wirtDoen="handleWriteDone1"
      :visible.sync="receiverSignFlag1"
      @change="handleReceiverSign"
    ></sign-dialog>
    <sign-dialog
      @wirtDoen="handleWriteDone2"
      :visible.sync="receiverSignFlag2"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 签名组件 -->

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :projectName="this.addFormData.project_name"
      :companyName="this.addFormData.company_name"
      :projectId="this.addFormData.project_id"
      :stageCode="'21'"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>

    <!-- 签名详情弹窗 -->
    <el-dialog
      :visible.sync="showDetailsDia"
      width="50%"
      class="addUserDia imgDetailsDia"
      :before-close="showDetailsDiaClose"
    >
      <div class="diaContainer">
        <img :src="showDetailsSign" alt />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
import SignDialog from '../SignDialog'
import UploadFile from '../UploadFile'
export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,
      showDetailsSign: '',
      showDetailsDia: false,
      detailsImgList: [],
      submitImgList: [],
      S_project_name: '',
      approval_remark: '',
      isSubmit: true,
      selectIds: [],
      infop: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_id: '',
      details_project_status: '',
      addFormData: {
        inspection_location: '',
        inspection_time: '',
        inspectors: '',
        site_record: '',
        // inspection_opinion: '',
        // sign_recorder: '',
        // sign_enterprise: '',
        annex: '',
      },
      // 签名
      receiverSignFlag1: false,
      receiverSignFlag2: false,
      writeDoneImg1: '',
      writeDoneImg2: '',
      // 签名
      topBarActive: '1',
      infop: '',
      member_id: '',
      token: '',
      value: '',
      isComponentsShow: false,
    }
  },
  methods: {
    // *撤回项目
    async handleProjectWithDraw() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('project_id', this.details_project_id)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/withdraw',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getProjectDetails()
      }, this.timeDou)
    },
    selectPermitChange() {
      if (this.addFormData.permit_type == '1') {
        this.addFormData.permit_type_sub = ''
      }
      if (this.addFormData.permit_type == '2') {
        this.addFormData.permit_type_sub = '1'
      }
    },
    // *审批提交
    async handleExamine(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.approval_remark)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/scene_approval',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *编辑提交
    async handleSubmit(val) {
      this.addFormData.member_json = JSON.stringify(this.tableData)
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('is_draft', val)
        param.append(
          'inspection_location',
          this.addFormData.inspection_location
        )
        param.append('inspection_time', this.addFormData.inspection_time)
        param.append('inspectors', this.addFormData.inspectors)
        param.append('site_record', this.addFormData.site_record)
        // param.append('inspection_opinion', this.addFormData.inspection_opinion)
        // param.append('sign_recorder', this.addFormData.sign_recorder)
        // param.append('sign_enterprise', this.addFormData.sign_enterprise)
        param.append('annex', JSON.stringify(this.submitImgList))
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/scene',
          data: param,
        })

        if (res.code != 200) {
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *获取项目详情
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/scene_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // 判断是不是首次到此流程
      if (res.datas.info.is_new != 1) {
        this.addFormData = res.datas.info
      }
      // 如果有项目名称
      if (this.addFormData.is_draft != '1' && this.addFormData.is_edit == '1') {
        this.isSubmit = false
      } else {
        this.isSubmit = true
      }
      this.S_project_name = res.datas.info.project_name

      // 判断签名
      // if (this.addFormData.sign_recorder == 'undefined') {
      //   this.addFormData.sign_recorder = ''
      // }
      // if (this.addFormData.sign_enterprise == 'undefined') {
      //   this.addFormData.sign_enterprise = ''
      // }
      // 判断文件上传
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      this.isComponentsShow = true
      console.log('项目任命书-详情', this.addFormData)
    },
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    // 签名
    handleWriteDone1(data) {
      this.addFormData.sign_recorder = data
    },
    handleWriteDone2(data) {
      this.addFormData.sign_enterprise = data
    },

    handleReceiverFlag1(url) {
      if (!this.isSubmit) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag1 = true
    },
    handleReceiverFlag2(url) {
      if (!this.isSubmit) {
        if (url) {
          this.showDetailsSign = url
          this.showDetailsDia = true
        }
        return
      }
      this.receiverSignFlag2 = true
    },
    handleReceiverSign() {},
    // 签名
    handleChange() {
      console.log(this.tableData1)
    },
    handleTopBarClikc(val) {
      this.topBarActive = val
    },
    async handleBefore(file) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('file', file)
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success('上传成功')
      this.editUserForm.avatar = res.datas.img_url
      console.log('头像', this.editUserForm.avatar)
    },
    showDetailsDiaClose() {
      this.showDetailsDia = false
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    if (this.details_project_status && this.details_project_id) {
      this.getProjectDetails()
    }
  },
  components: {
    SignDialog,
    UploadFile,
    ProjectFlow,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(../project/projectForm.less);
</style>